<template>
  <v-card :loading="loading">
    <v-simple-table>
      <thead>
        <tr>
          <th>Assignment</th>
          <th>Name</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="person in staff" :key="person.id">
          <td>{{person.title}}</td>
          <td :class="{ 'font-italic': person.name_preferred == 'Unassigned' }">{{person.name_preferred | assignmentFilter}}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-card>
</template>

<script>
export default {
  props: {
    staff: Array,
    loading: Boolean
  },
  filters: {
    assignmentFilter(name) {
      if(name == 'Unassigned') { return 'Not Yet Assigned' }
      else { return name }
    }
  }
}
</script>